import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {DokumentVersjonModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MAT_DIALOG_DATA, MatDialog, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {DokumentVisPdfIframeKomponent} from "../../komponenter/dokument-vis-pdf-iframe/dokument-vis-pdf-iframe";

const debug = initDebugger('DokumentVisPdfDialogKomponent');

/**
 * Viser dokument i PDF-viser som overlay
 */
@Component({
    selector: 'dokument-vis-pdf-dialog',
    templateUrl: 'dokument-vis-pdf-dialog.html',
    styleUrl: 'dokument-vis-pdf-dialog.scss',
    imports: [
        MatDialogContent,
        DokumentVisPdfIframeKomponent,
        MatIconButton,
        MatIcon,
        MatToolbar,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentVisPdfDialogKomponent {

    static vis(dialog: MatDialog, parametre: DialogParametre): MatDialogRef<DokumentVisPdfDialogKomponent, void> {
        return dialog.open(DokumentVisPdfDialogKomponent,
          {
              data: parametre,
              panelClass: 'dokument-vis-pdf-dialog',
              height: '80%',
              width: '80%'
          });
    }

    dokumentversjon: DokumentVersjonModell;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre, public dialogRef: MatDialogRef<DokumentVisPdfDialogKomponent>) {
        this.dokumentversjon = parametre.dokumentversjon;
    }

    lukk() {
        this.dialogRef.close();
    }
}

export interface DialogParametre {
    dokumentversjon: DokumentVersjonModell;
}
